const PRODUCT_ATTRIBUTE_PROPERTY = 'productId';
const PAINT_BRAND_ATTRIBUTE_PROPERTY = 'paintBrandId';
const COLOR_ATTRIBUTE_PROPERTY = 'colorId';

const PRODUCTION_PRODUCT_CATALOG_DOMAIN = 'https://products.hover.to';
const PRODUCTION_PRODUCT_CATALOG_URLS = {
  productsSrc: `${PRODUCTION_PRODUCT_CATALOG_DOMAIN}/hover_models/products.json`,
  manufacturersSrc: `${PRODUCTION_PRODUCT_CATALOG_DOMAIN}/hover_models/manufacturers.json`,
  manufacturerProductsSrc: `${PRODUCTION_PRODUCT_CATALOG_DOMAIN}/hover_models/manufacturer_products.json`,
};

const ELEMENT_PAINT_ATTRIBUTES = [
  {
    property: 'paintBrandId',
    name: 'Brand',
    callToAction: 'Paint Over',
    placeholder: 'Select Paint Brand',
  },
  {
    property: 'paintColorId',
    name: 'Color',
    placeholder: 'Select Paint Color',
  },
];

const ELEMENT_STYLE_ATTRIBUTES = [
  {
    property: 'materialId',
    name: 'Material',
    placeholder: 'Select Material',
  },
  {
    property: 'brandId',
    name: 'Brand',
    placeholder: 'Select Brand',
  },
  {
    property: PRODUCT_ATTRIBUTE_PROPERTY,
    name: 'Product',
    placeholder: 'Select Product',
  },
  {
    property: COLOR_ATTRIBUTE_PROPERTY,
    name: 'Color',
    placeholder: 'Select Color',
  },
];

const DESIGN_PRO_V2_OPTED_IN_LOCAL_STORAGE_KEY = 'hasOptedIntoDesignPro';
const PREVENT_REDIRECT_PARAM = 'prevent-redirect';

/**
 * In order for us to distinguish between the current Native
 * apps and the React Native Apps the native team put the
 * `app=native` as a query param with in the URL.
 * Jira: https://hoverinc.atlassian.net/browse/GROW-940
 * Jira NS: https://hoverinc.atlassian.net/browse/NS-1944
 */
const APP_TYPE_PARAM = 'app';

const MINIMUM_DESKTOP_SCREEN_PIXELS = 768; // in px
const MINIMUM_TABLET_SCREEN_PIXELS = 600; // in px

/**
 * We report the mode name as PREVIEW_MODE_NAME for metrics, when no mode is
 * active in the app
 */
const PREVIEW_MODE_NAME = 'preview';

const MODE_NAMES = {
  DESIGN: 'design',
  MEASURE: 'measure',
  SCREENSHOT: 'Screenshot',
};

const MEASUREMENTS_LABELS = {
  surfaceAreas: 'Surface Areas',
  openings: 'Openings',
};

const HORIZONTAL_SPLIT_MODE = 'horizontal';
const VERTICAL_SPLIT_MODE = 'vertical';
const SPLIT_MODES = {
  HORIZONTAL: HORIZONTAL_SPLIT_MODE,
  VERTICAL: VERTICAL_SPLIT_MODE,
};

const MAXIMUM_UNDO_ENTRIES = 1000;

export default {
  APP_TYPE_PARAM,
  COLOR_ATTRIBUTE_PROPERTY,
  DESIGN_PRO_V2_OPTED_IN_LOCAL_STORAGE_KEY,
  ELEMENT_PAINT_ATTRIBUTES,
  ELEMENT_STYLE_ATTRIBUTES,
  MAXIMUM_UNDO_ENTRIES,
  MEASUREMENTS_LABELS,
  MINIMUM_DESKTOP_SCREEN_PIXELS,
  MINIMUM_TABLET_SCREEN_PIXELS,
  MODE_NAMES,
  PAINT_BRAND_ATTRIBUTE_PROPERTY,
  PREVENT_REDIRECT_PARAM,
  PREVIEW_MODE_NAME,
  PRODUCT_ATTRIBUTE_PROPERTY,
  PRODUCTION_PRODUCT_CATALOG_URLS,
  SPLIT_MODES,
};
